import {Column, Entity, ManyToOne, RelationId} from "typeorm";
import {BaseEntity} from "@/modules/base/entity";
import {Min} from "class-validator";
import {Division} from ".";
import {PromotionIconEnum} from "@/modules/competitions/enums";
import {ColorEnum} from "@/modules/vue/enums";

@Entity()
export class DivisionPromotion extends BaseEntity {
  @ManyToOne(() => Division, division => division.promotions)
  division: Division;

  @RelationId((m: DivisionPromotion) => m.division)
  divisionId: number;

  @Column({type: 'integer', nullable: true})
  @Min(0)
  rank_form?: number;

  @Column({type: 'integer', nullable: true})
  @Min(0)
  rank_to?: number;

  @ManyToOne(() => Division, r => r.targetedPromotions, {nullable: true, eager: true})
  target_division?: Division;

  @RelationId((m: DivisionPromotion) => m.target_division)
  targetDivisionId: number;

  @Column({type: 'integer'})
  @Min(0)
  price = 0;

  @Column({type: 'boolean'})
  showInTable = true;

  @Column({type: 'boolean'})
  endOfTheSeason = false;

  @Column({type: 'varchar', enum: ColorEnum, nullable: true})
  colorInTable?: ColorEnum;

  @Column({type: 'varchar', enum: PromotionIconEnum, nullable: true})
  icon?: PromotionIconEnum;

  @Column({type: 'boolean'})
  showIconInTable = true;

  public isForRank(rank: number | undefined) {
    return rank !== undefined && this.rank_form! <= rank && this.rank_to! >= rank;
  }
}
